import { getFile } from '../common';
import { ENVIRONMENT, KURLY_MALL_CONFIG } from '../../configs/config';
import { KurlyMallConfig } from '../../interfaces/KurlyMallConfig';
import { DEFAULT_CONFIG } from '../../constant/defaultConfig';

export const fetchKurlyMallConfig = async (): Promise<KurlyMallConfig> => {
  try {
    const data = await getFile<KurlyMallConfig>(KURLY_MALL_CONFIG[ENVIRONMENT]);
    return data;
  } catch (error) {
    return DEFAULT_CONFIG;
  }
};
